import { Component, inject, Input } from '@angular/core';
import { TelegramModalsService } from "../../../../services/telegram-modals.service";
import { TelegramSaveFileModalService } from "../../../../services/telegram-save-file-modal.service";
import { ErrorService } from "../../../../../../../core/services/error.service";
import { TelegramChatsService } from "../../../../services/telegram-chats.service";
import { MatMiniFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-telegram-button-save-file',
  standalone: true,
  imports: [
    MatMiniFabButton,
    MatTooltip,
    MatIcon
  ],
  templateUrl: './telegram-button-save-file.component.html',
  styleUrl: './telegram-button-save-file.component.scss'
})
export class TelegramButtonSaveFileComponent {
  @Input({ required: true }) messageId: number = 0;

  private telegramModalsService: TelegramModalsService = inject(TelegramModalsService);
  private telegramSaveFileModalService: TelegramSaveFileModalService = inject(TelegramSaveFileModalService);
  private errorService: ErrorService = inject(ErrorService);
  private telegramChatsService: TelegramChatsService = inject(TelegramChatsService);

  public async handleSave(): Promise<void> {
    await this.initialize();
    if (!this.telegramSaveFileModalService.recordCalenderIdSelectData().length) {
      this.errorService.showErrorMessage('Блогер не привязан к рекламе!');
      return;
    }

    this.telegramModalsService.openSaveFileToSThree(this.messageId);
  }

  private async initialize(): Promise<void> {
    const chatId = this.telegramChatsService.chat()?.id || 0;
    if (!chatId) {
      this.errorService.showErrorMessage('Не выбран чат!')
      return;
    }

    await this.telegramSaveFileModalService.initialize(chatId);
  }
}
